import React, {Component} from 'react';
import { Elements } from 'react-stripe-elements';
import {Helmet} from "react-helmet";
import { connect } from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';
import { productTypeUpdated, RESPONSE_STATUS } from '../../../utils/constants';
import Rating from 'react-rating';
import ReactSVG from 'react-svg';
import StorySectionitem from './storySectionitem';
import StorySectionitemPhone from './storySectionitemPhone';
import StoriesShowItem from './storiesShowItem'
import Slider from 'react-slick';
import * as zenscroll from 'zenscroll';
import Responsive from 'react-responsive';
import Api from '../../../utils/api';

import PlanGatePay from './planGatePay'
import PlanGatePayPhone from './planGatePayPhone'
import './planView.css'

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slick-arrow custom-arrow-right"}
        onClick={onClick}
      />
    );
}

function SamplePrevArrowPhone(props) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
      />
    );
}

  
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slick-arrow custom-arrow-left"}
        onClick={onClick}
      />
    );
}

class planView extends Component {
    constructor(props) {
        super(props);

        this.handleOpenModesGuarantee = this.handleOpenModesGuarantee.bind(this);

        this.state = {
            storySectionInfo:[
                {
                    title: 'Sydney',
                    quote: 'HelloAva broke down my skincare issues and set me up with a routine that has truly changed my skin. My friends have noticed my complexion and my skin is starting to glow!',
                    skinConcerns: 'Wrinkles, Dullness, Dark Circles, Acne',
                    skinType: 'Dry, Sensitive, Pigmented, Mature',
                    letImg:"../images/plan/story/SydneyAdel/sydneyBefore.jpg",
                    rightImg:"../images/plan/story/SydneyAdel/sydneyAfter.jpg",
                    img1: "../images/plan/story/SydneyAdel/900-1.png",
                    img2: "../images/plan/story/SydneyAdel/chrono-calm.png",
                    img3: "../images/plan/story/SydneyAdel/upc.png",
                    img1Text:"Cleanse",
                    img2Text:"Serum",
                    img3Text:"SPF",
                },
                {
                    title: 'Jesse',
                    quote: 'My blemishes disappeared within a day and I really enjoy keeping up with my skin care routine! It’s a really special part of my day honoring myself.',
                    skinConcerns: 'Redness, Oiliness, Wrinkles, Dullness, Dryness, Acne',
                    skinType: 'Combination, Sensitive, Light, Mature',
                    letImg:'../images/plan/story/JesseCarreyChan/jesse.jpeg',
                    img1: "../images/plan/story/JesseCarreyChan/ScreenShot.png",
                    img2: "../images/plan/story/JesseCarreyChan/facefora.png",
                    img3: "../images/plan/story/JesseCarreyChan/61VR1yNuo.png",
                    img1Text:"Cleanse",
                    img2Text:"Tone",
                    img3Text:"Moisturize",
                },
                {
                    title: 'Kai',
                    quote: 'Hello Ava has helped me immensely! I still get the occasional pimple or breakout, but overall my skin has improved tenfold.',
                    skinConcerns: 'Dark Spots, Dullness, Clogged Pores, Acne',
                    skinType: 'Combination, Sensitive, Hyperpigmented, Young',
                    letImg: "../images/plan/story/KaiMytae/kaiBefore.jpg",
                    rightImg: "../images/plan/story/KaiMytae/kaiAfter.jpg",
                    img1: "../images/plan/story/KaiMytae/sensitive.png",
                    img2: "../images/plan/story/KaiMytae/Everyday_Face.png",
                    img3: "../images/plan/story/KaiMytae/3d7.png",
                    img1Text:"Cleanse",
                    img2Text:"Serum",
                    img3Text:"Moisturize",
                },
                {
                    title: 'Asiana',
                    quote: 'Learning the importance of exfoliation, toning, and which ingredients worked best for me allowed me to achieve glowing skin.',
                    skinConcerns: 'Oiliness, Dark Spots, Dullness, Dryness, Dark Circles',
                    skinType: 'Combination, Pigmented, Non-sensitive, Young',

                    letImg: "../images/plan/story/AsianaJones/asianaBefore.jpeg",
                    rightImg: "../images/plan/story/AsianaJones/AsianaAfter.jpeg",

                    letImgPhone: "../images/plan/story/AsianaJones/asianaBefore.jpeg",
                    rightImgPhone: "../images/plan/story/AsianaJones/AsianaAfter.jpeg",

                    img1: "../images/plan/story/AsianaJones/b479d175.png",
                    img2: "../images/plan/story/AsianaJones/610.png",
                    img3: "../images/plan/story/AsianaJones/ScreenShot.png",
                    img1Text:"Cleanse",
                    img2Text:"Serum",
                    img3Text:"Moisturize",
                },
                
            ],
            sliderSettings:{
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false,
                autoplay: true,
                autoplaySpeed:3000,
                fade: true,
                pauseOnHover: false,
                customPaging: function(i) {
                    return (
                      <i className="custom-dots-s"></i>
                    );
                },
                dotsClass: "slick-dots slick-thumb",
            },
            stateplanGuarantee:false,

            storiceData:[

                {
                    name:'Kitera D.',
                    textData:'“The best part is she listened to what I wanted and only recommended those things instead of trying to sell me on a whole new routine. That leaves me feeling like HelloAva actually cares about helping their customers.”',
                    roundImg:'./images/plan/stories/storiesIcon3.svg',
                    realImg:'./images/plan/real/pc/1.jpg',
                    realImg_mobile:'./images/plan/real/mobile/1.jpg',
                },
                {
                    name:'Tiffany S',
                    textData:'“Mandy was very informative and helpful with my specific needs! She really made me feel like comfortable and that she wanted to make sure I was able to get what I was looking for. ”',
                    roundImg:'./images/plan/stories/storiesIcon6.svg',
                    realImg:'./images/plan/real/pc/2.jpg',
                    realImg_mobile:'./images/plan/real/mobile/2.jpg',
                },
                {
                    name:'Nicole C',
                    textData:'“It went amazingly! My favorite part was how kind and encouraging Mandy was! My skincare concerns were so validated and I felt so uplifted.”',
                    roundImg:'./images/plan/stories/storiesIcon8.svg',
                    realImg:'./images/plan/real/pc/3.jpg',
                    realImg_mobile:'./images/plan/real/mobile/3.jpg',
                },
                {
                    name:'Derek F.',
                    textData:'“Really felt as though she was listening to my concerns and gave me great detail about things to use, to reduce, and things to implement into routine. Fantastic”',
                    roundImg:'./images/plan/stories/storiesIcon2.svg',
                    realImg:'./images/plan/real/pc/4.jpg',
                    realImg_mobile:'./images/plan/real/mobile/4.jpg',
                },
                {
                    name:'Elisabeth C',
                    textData:'“Kathleen was really easy to talk to and helped me identify what I was missing in my routine. She made great suggestions on how to build my routine and listened to my concerns, my preferences and had a great assessment of my skin.”',
                    roundImg:'./images/plan/stories/storiesIcon5.svg',
                    realImg:'./images/plan/real/pc/5.jpg',
                    realImg_mobile:'./images/plan/real/mobile/5.jpg',
                },
                {
                    name:'Olivia H.',
                    textData:'“Kathleen was really thorough in going over my current skincare regimen and kindly explaining what I need to change and why. She was very knowledgeable about what ingredients and products would be best for my skin type.”',
                    roundImg:'./images/plan/stories/storiesIcon4.svg',
                    realImg:'./images/plan/real/pc/6.jpg',
                    realImg_mobile:'./images/plan/real/mobile/6.jpg',
                },
                {
                    name:'Michelle M',
                    textData:'“Kathleen was such a kind presence, and she was very knowledgeable! We had a great dialogue on my current routine and my concerns. Shortly after our call, I had personalized recommendations that actually get me super excited for my skincare routine!”',
                    roundImg:'./images/plan/stories/storiesIcon7.svg',
                    realImg:'./images/plan/real/pc/7.jpg',
                    realImg_mobile:'./images/plan/real/mobile/7.jpg',
                },
                {
                    name:'Kelsey P.',
                    textData:'“It was really nice to show her what I actually was using because I was at home. She took into account my budget and what my needs and wants were. I wanted a simple routine so she didn’t recommend things I didn’t need.”',
                    roundImg:'./images/plan/stories/storiesIcon1.svg',
                    realImg:'./images/plan/real/pc/8.jpg',
                    realImg_mobile:'./images/plan/real/mobile/8.jpg',
                },

                {
                    name:'Elisabeth C',
                    textData:'“Kathleen was really easy to talk to and helped me identify what I was missing in my routine. She made great suggestions on how to build my routine and listened to my concerns, my preferences and had a great assessment of my skin.”',
                    roundImg:'./images/plan/stories/storiesIcon5.svg',
                },
                {
                    name:'Tiffany S',
                    textData:'“Mandy was very informative and helpful with my specific needs! She really made me feel like comfortable and that she wanted to make sure I was able to get what I was looking for. ”',
                    roundImg:'./images/plan/stories/storiesIcon6.svg',
                },
                {
                    name:'Michelle M',
                    textData:'“Kathleen was such a kind presence, and she was very knowledgeable! We had a great dialogue on my current routine and my concerns. Shortly after our call, I had personalized recommendations that actually get me super excited for my skincare routine!”',
                    roundImg:'./images/plan/stories/storiesIcon7.svg',
                },
                {
                    name:'Nicole C',
                    textData:'“It went amazingly! My favorite part was how kind and encouraging Mandy was! My skincare concerns were so validated and I felt so uplifted.”',
                    roundImg:'./images/plan/stories/storiesIcon8.svg',
                },
            ],
            storiesSettings:{
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:true,
                prevArrow: <SamplePrevArrow />,
                nextArrow: <SampleNextArrow />,
                fade: true,
                autoplay: true,
                autoplaySpeed:4000,

                // fade: true,
                // pauseOnHover: false,

                customPaging: function(i) {
                    return (
                        <i className="custom-dots-s"></i>
                    );
                },
                dotsClass: "slick-dots slick-thumb",
                responsive: [
                    {
                      breakpoint: 766,
                      settings: {
                        dots: true,
                        infinite: true,
                        speed: 600,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        fade: false,
                        prevArrow: <SamplePrevArrowPhone></SamplePrevArrowPhone>,
                        nextArrow: <SampleNextArrow />,
                      }
                    }
                ]    

            },
          
        };
    }

    componentWillMount() {
        if (localStorage.getItem("user_id")) {
            if(localStorage.getItem("gateFeePaid")  == "true"){
                if(localStorage.getItem("planTier") == "1" ){
                    this.props.history.push('/recommendations');
                }else{
                    this.props.history.push('/recommendation-landing');
                }
            }
        }else{
            this.props.history.push('/signin');
			return;
        }
    }



    componentDidMount() {
        // try {
        //     window.zE("webWidget", {chat: {
        //         supress: false
        //     }}, "show");
        // } catch (error) {}
      
    }

    componentDidUpdate(){
        var recommendationDom = document.getElementById("comment-package-area");
		if(recommendationDom){
			recommendationDom.addEventListener('touchstart', this.touchStart);
			recommendationDom.addEventListener('touchmove', this.preventTouch, {passive: false});
		}
    }

    componentWillUnmount() {
		window.removeEventListener('touchstart', this.touchStart);
		window.removeEventListener('touchmove', this.preventTouch, {passive: false});
    }

    componentWillUnmount() {
        // try {
        //     window.zE("webWidget", "hide");
        // } catch (error) {}
        
    }
    
    touchStart(e){
		this.firstClientX = e.touches[0].clientX;
		this.firstClientY = e.touches[0].clientY;
	}
	
	preventTouch(e){
		const minValue = 10; // threshold
		this.clientX = e.touches[0].clientX - this.firstClientX;
		this.clientY = e.touches[0].clientY - this.firstClientY;
		// Vertical scrolling does not work when you start swiping horizontally.
		if(Math.abs(this.clientX) > minValue){ 
			e.preventDefault();
			e.returnValue = false;
			return false;
		}
    }
    
    handleOpenModesGuarantee(){
        this.setState({
            stateplanGuarantee: !this.state.stateplanGuarantee
        })
    }

    render() {
        const userFirstName = localStorage.getItem('user_firstname');
        return (
                <div name="planView-area" style={{width:'100%'}}>
                    <Helmet>
                        <title>3-Plan - HelloAva</title>
                        <meta name="description" content="Here are the results of your skin care questionaire!" />
                    </Helmet>
                    
                    <div className="pc-area-plan">
                        <div className="title-hello-name plan-title-hello-name">
                            <div className="t-h-name-text-area">
                                <div className="t-h-name">
                                    <img src="./images/profile/hand.svg"/> 
                                    <span className="heading1">Hello, { userFirstName }!</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="publicView " style={{width:'100%'}}>
                        <div className="pc-area-plan">
                            <div className="plan-area-style plan-select-area">
                                <div className="skin-type-hello-title" style={{marginBottom:'1.7em',}}>Choose your preferred package</div>
                                <Responsive minWidth={ 767 }>
                                    <Elements>
                                        <PlanGatePay handleOpenModesGuarantee={this.handleOpenModesGuarantee}></PlanGatePay>
                                    </Elements>
                                </Responsive>          
                                <Responsive maxWidth={ 767 }>
                                    <Elements>
                                        <PlanGatePayPhone handleOpenModesGuarantee={this.handleOpenModesGuarantee}></PlanGatePayPhone>
                                    </Elements>
                                </Responsive>
                            </div>
                        </div>

                        <div className="public-section-area esthetician-show-area">
                            <div className="esthetician-items-area">
                                <div className="esth-left-items esth-items">
                                    <div className="paragraphBold1 esth-items-title">Consult a licensed Esthetician at your fingertips</div>
                                    <div className="paragraphRegular3 esth-items-text">We’ll customize a routine with a holistic approach to achieve your skin goals</div>
                                    <div className="esth-items-img"><img src="./images/plan/plane-sthetician-a.png"></img></div>
                                </div>
                                <div className="esth-right-items esth-items">
                                    <div className="paragraphBold1 esth-items-title esth-items-mm">No more guessing & Googling on your own</div>
                                    <div className="paragraphRegular3 esth-items-text">Know what each product targets and  why it is most effective for your unique skin type</div>
                                    <div className="esth-items-img"><img src="./images/plan/No-more-guessing.png"></img></div>
                                </div>
                            </div>
                        </div>

                        <div className="public-section-area risk-ree-area">
                            <div className="risk-ree-area-items">
                                <ul>
                                    <li className="paragraphBold1">Try it Risk-free</li>
                                    <li className="paragraphRegular3">We are confident in our selections for you. Try them, test them out, and if there’s anything you don’t love, send them back.</li>
                                    <li>
                                        <button className="button-style" onClick={()=>{ zenscroll.toY(0) }}>Choose your package</button>
                                    </li>
                                </ul>
                            </div>
                        </div>



                        <div className="plan-area-style stories-show-zone">
                            <div className="skin-type-hello-title" style={{marginBottom:'1.7em'}}>Real stories, unedited</div>
                            <div style={{maxWidth:'1440px'}}>
                                <div className="stories-show-area">
                                    <Slider { ...this.state.storiesSettings }>
                                        {
                                            this.state.storiceData.map((item, index)=>{
                                                return <StoriesShowItem data={item} key={index} index={ index }></StoriesShowItem>
                                            })
                                        }
                                    </Slider>
                                </div>
                            </div>
                        </div>

                            
                        {/* <div className="comment-package-area" id="comment-package-area" >
                            <Responsive minWidth={ 767 }>
                                <Slider { ...this.state.sliderSettings }>
                                    {
                                        this.state.storySectionInfo.map((item, index)=>{
                                            return <StorySectionitem data={item} key={index} index={ index }></StorySectionitem>
                                        })
                                    }
                                </Slider>
                            </Responsive>

                            <Responsive maxWidth={ 767 }>
                                <Slider { ...this.state.sliderSettings }>
                                    {
                                        this.state.storySectionInfo.map((item, index)=>{
                                            return <StorySectionitemPhone data={item} index={ index } key={index}></StorySectionitemPhone>
                                        })
                                    }
                                </Slider>
                            </Responsive>
                        </div> */}

{/* 
                        <div className="plan-area-style" >
                            <div className="approach-area">
                                <div className="skin-type-hello-title">The HelloAva approach</div>
                                <div className="approach-area-conten">
                                    <div className="approach-area-conten-item">
                                        <img src="../images/plan/large/chat.svg"/>
                                        <div className="approach-area-conten-item-title">Licensed skin<br/>experts</div>
                                        <div className="approach-area-conten-item-text"> All of our skin experts are certified <Responsive minWidth={ 767 }><br/></Responsive> by the NY State Esthetics <Responsive minWidth={ 767 }> <br/></Responsive> Licensing Board</div>
                                    </div>

                                    <div className="approach-area-conten-item">
                                        <img src="../images/plan/large/ondemand.svg"/>
                                        <div className="approach-area-conten-item-title">We are<br/>always here</div>
                                        <div className="approach-area-conten-item-text">Reach out to your licensed  <Responsive minWidth={ 767 }><br/></Responsive> skin expert anytime </div>
                                    </div>

                                    <div className="approach-area-conten-item">
                                        <img src="../images/plan/large/care.svg"/>
                                        <div className="approach-area-conten-item-title">Unbiased<br/>recommendations</div>
                                        <div className="approach-area-conten-item-text">Always put your interest first. All 150+ <Responsive minWidth={ 767 }><br/></Responsive> brands on HelloAva are rigorously vetted <Responsive minWidth={ 767 }><br/></Responsive> by our skin experts</div>
                                    </div>

                                </div>
                            </div>

                            <div className="skin-type-hello-title" style={{marginTop: '3.77em'}}>Professional consultation at your fingertips</div>
                            <div className="professional-area">
                                <div className="bitmap-img">
                                    <img className="bitmap-img" src="../images/plan/VIdeo_con.png"></img>
                                </div>
                                <div className="right-describe-area">
                                    <div className="row-describe-item">
                                        <div className="row-describe-item-title">What’s in a virtual consultation?</div>
                                        <div className="row-describe-item-datail-text">Your dedicated skin expert will take a close-up look at your skin, review your skin summary, concerns and what products you are currently using before tailoring your skincare routine.</div>
                                    </div>
                                    <div className="row-describe-item">
                                        <div className="row-describe-item-title">Why do I need a consultation?</div>
                                        <div className="row-describe-item-datail-text">Skincare is never one size fits all. This is a key step for us to make sure we are recommending products tailored to your unique needs. </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}


                        <div style={{textAlign:'center',marginTop:'8em'}}>
                            <button className="button-style" onClick={()=>{ zenscroll.toY(0) }}>Choose your package</button>
                        </div>

                        <div className="home-freesh-modal" style={ this.state.stateplanGuarantee ?{display:'block'}:{display:'none'}}>
                                <div className="freesh-over-bg" onClick={()=>{  this.handleOpenModesGuarantee() }}></div>
                                <div className="plan-guarantee home-confirm-conten">
                                    <div className="plan-guarantee-area">
                                        <li className="h5-text plan-guarantee-title">Money-Back Guarantee & Details of Purchase</li>
                                        <li className="p_text plan-guarantee-text">
                                            <p>We are confident that our consultation and  products recommended will help you achieve your skincare goals. If you feel that we did not provide you with the tools to meet your goals, we will be happy to issue you a refund within 7 days of your purchase.</p>
                                            <p>Please email our support team at customersuccess@helloava.co within the 7-day purchase window, and let us know you’d like a refund. Refund requests must be emailed to customersuccess@helloava.co and not messaged via any of the HelloAva social channels. Refund requests submitted via Instagram or any other social platform will not be processed.</p>
                                            <p>All one-on-one video consults are <br/> non-refundable once conducted.</p>
                                        </li>
                                    </div>
                                </div>
                        </div>
                    </div>
                    {/* <!-- Your Chat Plugin code --> */}
                    {/* <div className="fb-customerchat"
                        attribution="install_email"
                        page_id="1809451302622337"
                        theme_color="#FFAD94"
                        title = 'Chat with a real human'
                        logged_in_greeting="Got questions? "
                        logged_out_greeting="Got questions? ">
                    </div> */}
                </div>
        );
    }
}


export default withRouter(planView);



// WEBPACK FOOTER //
// ./src/views/AA/plan/planView.js